module.exports = __webpack_public_path__ + "img/b.cd1ad14a.png";